<!-- Modal Overlay -->
<div class="modal-overlay" *ngIf="visible" (click)="onOverlayClick($event)">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-icon">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <line x1="50" y1="8" x2="50" y2="18" class="ray"/>
          <line x1="71" y1="15" x2="64" y2="22" class="ray"/>
          <line x1="85" y1="35" x2="75" y2="35" class="ray"/>
          <line x1="78" y1="55" x2="70" y2="48" class="ray"/>
          <line x1="22" y1="55" x2="30" y2="48" class="ray"/>
          <line x1="15" y1="35" x2="25" y2="35" class="ray"/>
          <line x1="29" y1="15" x2="36" y2="22" class="ray"/>
          <path class="bulb" d="M 50 25 C 41 25 34 32 34 41 C 34 46 36 50 38 54 L 38 60 C 38 62 40 64 42 64 L 58 64 C 60 64 62 62 62 60 L 62 54 C 64 50 66 46 66 41 C 66 32 59 25 50 25 Z" fill="none"/>
          <rect x="42" y="64" width="16" height="4" rx="1" class="base" fill="none"/>
          <rect x="42" y="68" width="16" height="4" rx="1" class="base" fill="none"/>
        </svg>
      </div>
      <div class="header-text">
        <h2>Share Your Feedback</h2>
        <p>Suggest Features & Improvements</p>
      </div>
      <button type="button" class="close-button" (click)="onClose()">
        <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-content" *ngIf="!showSuccess">
    <!-- Step 1: Summary -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="form-group">
        <label class="form-label">Give us a quick one-line summary of your idea or feature</label>
        <span class="form-hint">You can add more detail in the next step</span>
        <input 
          type="text" 
          pInputText 
          [(ngModel)]="summary"
          placeholder="e.g., Add dark mode to the dashboard"
          class="form-input"
          [class.invalid]="summary.trim().length === 0 && summary.length > 0"
        />
      </div>
    </div>

    <!-- Step 2: Details -->
    <div class="step-content" *ngIf="currentStep === 2">
      <!-- Description -->
      <div class="form-group">
        <label class="form-label">Tell us more about your suggestion</label>
        <span class="form-hint">How would this help you? Any specific details?</span>
        <textarea 
          pInputTextarea 
          [(ngModel)]="details"
          rows="4"
          class="form-textarea"
          placeholder="Describe your idea in more detail..."
        ></textarea>
      </div>

      <!-- Attachments -->
      <div class="form-group">
        <label class="form-label">Attachments <span style="font-weight: 400; color: #9ca3af;">(optional)</span></label>
        <div 
          class="file-upload-area"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
        >
          <div class="upload-icon">
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
            </svg>
          </div>
          <div class="upload-content">
            <span class="upload-text">Attach files</span>
            <span class="upload-hint">PDF, Excel, JPG, PNG (max 10MB)</span>
          </div>
          <input 
            type="file" 
            (change)="onFileSelect($event)"
            [accept]="'.pdf,.xls,.xlsx,.jpg,.jpeg,.png'"
            multiple
            class="file-input"
          />
        </div>
        
        <!-- Attached files list -->
        <div class="attachments-list" *ngIf="attachments.length > 0">
          <div class="attachment-item" *ngFor="let attachment of attachments; let i = index">
            <i [class]="getFileIcon(attachment.type)" [style.color]="getFileIconColor(attachment.type)"></i>
            <span class="attachment-name">{{ attachment.name }}</span>
            <span class="attachment-size">{{ formatFileSize(attachment.size) }}</span>
            <button type="button" class="remove-attachment" (click)="removeAttachment(i)">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Category -->
      <div class="form-group">
        <label class="form-label">What type of suggestion is this?</label>
        <p-dropdown
          class="w-100"
          [(ngModel)]="selectedCategory"
          [options]="categoryOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select a category..."
          styleClass="category-dropdown"
          appendTo="body"
          [panelStyleClass]="'category-dropdown-panel dropdown-opens-up'"
        >
          <ng-template pTemplate="selectedItem" let-item>
            <div class="category-item" *ngIf="item">
              <svg class="category-icon" width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.svgPath" />
              </svg>
              <span>{{ item.label }}</span>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-item>
            <div class="category-item">
              <svg class="category-icon" width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.svgPath" />
              </svg>
              <span>{{ item.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <!-- Step 3: Priority -->
    <div class="step-content" *ngIf="currentStep === 3">
      <div class="form-group">
        <label class="form-label">How important is this to you?</label>
        
        <div class="priority-options">
          <div 
            *ngFor="let option of priorityOptions" 
            class="priority-option"
            [class.selected-high]="selectedPriority === option.value && option.value === 'High'"
            [class.selected-medium]="selectedPriority === option.value && option.value === 'Medium'"
            [class.selected-low]="selectedPriority === option.value && option.value === 'Low'"
            (click)="selectedPriority = option.value"
          >
            <span class="priority-indicator" [ngClass]="option.value.toLowerCase()"></span>
            <div class="priority-content">
              <span class="priority-label">{{ option.label }}</span>
              <span class="priority-description">{{ option.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Preview -->
      <div class="summary-preview">
        <p class="preview-label">Your suggestion:</p>
        <p class="preview-text">"{{ summary }}"</p>
      </div>
    </div>
  </div>

    <!-- Success Message -->
    <div class="modal-content success-content" *ngIf="showSuccess">
    <div class="success-icon">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h4 class="success-title">Thank you for your feedback!</h4>
    <p class="success-message">
      Your suggestion has been submitted successfully. We really appreciate you taking the time to help us improve.
    </p>
  </div>

    <!-- Footer -->
    <div class="modal-footer" *ngIf="!showSuccess">
      <!-- Navigation Buttons -->

      <div class="footer-buttons">
        <button 
          *ngIf="currentStep > 1"
          type="button" 
          pButton 
          class="p-button-secondary back-button"
          (click)="previousStep()"
        >
          Back
        </button>
        
        <button 
          *ngIf="currentStep < totalSteps"
          type="button" 
          pButton 
          class="p-button-primary continue-button"
          [disabled]="!canProceedToNextStep()"
          (click)="nextStep()"
        >
          Continue
        </button>

        <button 
          *ngIf="currentStep === totalSteps"
          type="button" 
          pButton 
          class="p-button-success submit-button"
          (click)="submitFeedback()"
        >
          Submit
        </button>
      </div>
      <!-- Progress Dots -->
      <div class="progress-dots">
        <span 
          *ngFor="let step of [1, 2, 3]" 
          class="dot" 
          [class.active]="step === currentStep"
          [class.completed]="step < currentStep"
          (click)="goToStep(step)"
        ></span>
      </div>


    </div>

    <div class="modal-footer success-footer" *ngIf="showSuccess">
      <button 
        type="button" 
        pButton 
        class="p-button-primary close-button"
        (click)="onSuccessClose()"
      >
        Close
      </button>
    </div>
  </div>
</div>
